/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Chart } from '@antv/g2';
import DataSet from '@antv/data-set';
import { GetIcon } from 'datastake-daf/dist/components';
import i18next from 'i18next';

export default function RiskProfile({
  data: defaultData = [],
  language,
  style = {
    height: 'calc(100% - 57px)',
    maxWidth: '100%',
    width: '100%',
  },
  type = 'DEFAULT',
  defaultFields = null,
  showLegend = false,
}) {
  const container = useRef();
  const [mainGraph, setMainGraph] = useState(null);
  const [graphWidth, setGraphWidth] = useState(0);
  const [graphHeight, setGraphHeight] = useState(0);

  const data = useMemo(() => {
    if (defaultData.length === 2) {
      return [
        { item: "", Current: 0, Baseline: 0 },
        defaultData[0],
        defaultData[1],
      ]
    }

    return defaultData;
  }, [defaultData]);

  const [graphData, setGraphData] = useState(data);

  const observer = useRef(new ResizeObserver((entries) => {
    window.requestAnimationFrame(() => {
      const { width, height } = entries[0].contentRect;
      setGraphWidth(width);
      setGraphHeight(height);
    });
  }));
  useEffect(() => {
    if (mainGraph && (mainGraph.width !== graphWidth || mainGraph.height !== graphHeight) && graphWidth && graphHeight) {
      // mainGraph.forceFit();
      let gHeight = graphWidth * 0.63;
      if (type === 'RISK_PROFILE' && gHeight < 290) {
        gHeight = 290;
      }

      if (type === 'RISK_CATEGORIES' && gHeight > 300) {
        gHeight = 300;
      }
      if (gHeight < 300 && type === 'RISK_CATEGORIES') {
        gHeight = 260;
      }
      if (gHeight < 180 && type !== 'RISK_CATEGORIES') {
        gHeight = 404 - gHeight;
      }
      let gWidth = graphWidth;
      // if (mainGraph.height !== graphHeight) {
      //   gWidth = gHeight / 0.63
      // }
      // if (mainGraph.width !== graphWidth) {
      //   gHeight = gWidth * 0.63;
      // }

      //if (type === 'DASHBOARD') {
      //gHeight = graphWidth;
      //}
      mainGraph.changeSize(gWidth, gHeight);
      // mainGraph.render(true);
      if (graphWidth < 300) {
        const gData = JSON.parse(JSON.stringify(data)).map((d, i) => {
          if (![0, 3].includes(i)) {
            d.item = d.item.split('\n').join(' ').split(' ').join('\n');
          }
          return d;
        });
        setGraphData([
          ...gData
        ]);
      } else {
        setGraphData([
          ...data
        ]);
      }
      const dif = type === 'LABEL_SMALL' ? 1 : 0;
      let fontSize = 12 - dif;
      if (graphWidth < 400) {
        fontSize = 11 - dif;
      } else if (graphWidth < 350) {
        fontSize = 10 - dif;
      } else if (graphWidth < 300) {
        fontSize = 9 - dif;
      } else if (graphWidth < 250) {
        fontSize = 8 - dif;
      }
      mainGraph.axis('item', {
        line: null,
        tickLine: null,
        label: {
          autoHide: true,
          style: {
            fontSize,
          }
        },
        grid: {
          line: {
            style: {
              lineDash: null,
            },
          },
        },
      });
      mainGraph.axis('score', {
        line: null,
        tickLine: null,
        label: {
          autoHide: true,
          style: {
            fontSize,
          }
        },
        grid: {
          line: {
            type: 'line',
            style: {
              lineDash: null,
            },
          },
        },
      });
      mainGraph.render(true);
    }
  }, [graphWidth, graphHeight, mainGraph]);

  useEffect(() => {
    setGraphData(data);
  }, [data, language]);
  useEffect(() => {
    if (container.current) {
      observer.current.observe(container.current);
    }
    return () => {
      if (container.current) {
        observer.current.unobserve(container.current);
      }
    }
  }, [container.current, observer]);

  const getHeight = () => {
    if (type === 'RISK_CATEGORIES') {
      if (container.current.offsetHeight > 300) {
        return 300;
      }
    }
    return container.current.offsetHeight
  }

  useEffect(() => {
    if (container.current) {
      const { DataView } = DataSet;
      const dv = new DataView().source(data);
      dv.transform({
        type: 'fold',
        fields: defaultFields || [i18next.t('Baseline'), i18next.t('Current')],
        key: 'user',
        value: 'score',
      });
      if (mainGraph) {
        mainGraph.data(dv.rows);
        mainGraph.render(true);
      } else {
        const chart = new Chart({
          container: container.current,
          // autoFit: true,
          height: getHeight(),
          width: container.current.offsetWidth * 0.8,
          // renderer: 'svg',
        });
        chart.data(dv.rows);
        chart.scale('score', {
          min: 0,
          max: 5,
          showLast: false,
          sync: true,
        });
        chart.coordinate('polar', {
          radius: 0.8,
        });
        chart.tooltip({
          shared: true,
          showCrosshairs: true,
          crosshairs: {
            line: {
              style: {
                lineDash: [4, 4],
                stroke: '#333'
              }
            }
          },
          customContent: (title, data) => {
            let content = '';
            if (data && data.length) {
              content = '<ul class="g2-tooltip-list"';
              data.forEach(v => {
                content += `<li class="g2-tooltip-list-item" data-index="" style="list-style-type: none; padding: 0px; margin: 12px 0px;">
                    <span class="g2-tooltip-marker" style="background: ${v.mappingData.color}; width: 8px; height: 8px; border-radius: 50%; display: inline-block; margin-right: 8px;"></span>
                    <span class="g2-tooltip-name">${v.name}</span>
                    <span class="g2-tooltip-value" style="display: inline-block; float: right; margin-left: 30px;">${v.value ? Number(v.value).toFixed(2) : '-'}</span>
                  </li>`;
              });
              content += '</ul>';
            }
            return `<div class="g2-tooltip">
              ${title ? `<div class="g2-tooltip-title" style="margin-bottom: 12px; margin-top: 12px;">${(title || '')}</div>` : ''}
              ${content}
            </div>`;
          }
        });
        chart.axis('item', {
          line: null,
          tickLine: null,
          label: {
            autoHide: true,
            style: {
              fontSize: 12,
            }
          },
          grid: {
            line: {
              style: {
                lineDash: null,
              },
            },
          },
        });
        chart.axis('score', {
          line: null,
          tickLine: null,
          label: {
            autoHide: true,
            style: {
              fontSize: 12,
            }
          },
          grid: {
            line: {
              type: 'line',
              style: {
                lineDash: null,
              },
            },
          },
        });
        chart.legend(false);
        // chart.legend({
        //   layout: 'horizontal',
        //   position: 'bottom-left',
        //   tooltip: false,
        //   label: {
        //     spacing: 2,
        //     style: {
        //       fontSize: 8
        //     }
        //   },
        // });
        // chart.tooltip({
        //   customContent: (title, data) => {
        //   }
        // });
        chart.annotation(false)
        chart
          .line()
          .position('item*score')
          .color('user')
          .size(2);
        chart
          .point()
          .position('item*score')
          .shape('circle')
          .color('user')
          .size(3)
          .style({
            stroke: '#fff',
            lineWidth: 1,
            fillOpacity: 1,
          });
        chart
          .area()
          .position('item*score')
          .color('user');
        // if (chart.animate) {
        //   chart.animate(false)
        // }
        // chart.axis(null);
        chart.render();
        setMainGraph(chart);
      }
    }
  }, [container, graphData])

  return (
    <div className="riskProfile risk-widget">
      {type !== 'RISK_CATEGORIES' && (
        <div className="title">
          <div>
            <GetIcon icon="folder-chart" type="line" style={{ color: '#BDBDBD' }} />
            <h1 className="risk-h1">{i18next.t('Risk Profile')}</h1>
          </div>
        </div>
      )}
      <div
        ref={container}
        className="risk-profile-container"
        style={{ ...style, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}
      > </div>
      {showLegend && (
        <div className="risk-profile-legend" style={{ marginTop: 20 }}>
          <div className="risk-group">
            <div className="risk-cont">
              <div className="risk-legend" style={{ background: 'var(--mmt-primary-70)' }} />
            </div>
            <div className="risk-cont">
              <label>Current</label>
            </div>
          </div>
          <div className="risk-group">
            <div className="risk-cont">
              <div className="risk-legend" style={{ background: '#47CAAA' }} />
            </div>
            <div className="risk-cont">
              <label>Baseline</label>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
